import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const shouldEnable =
  Boolean(dsn) &&
  (import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === "true");

if (shouldEnable && dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    // Same-origin only. Do NOT propagate to *.supabase.co: the trace headers
    // (sentry-trace, baggage) aren't in the edge functions' CORS allow-list, so
    // attaching them makes the preflight reject every functions.invoke() call.
    tracePropagationTargets: [/^\//],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    sendDefaultPii: false,
  });
}
